export default "__VITE_ASSET__DL0IPI5o__"